import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Uf, Municipio, ChaveValor, Loading, CEP } from '@app/shared/models';

import { GenericService } from '@app/core/services/generic.service';
import { AddHttpParams } from '@app/core/services/add-http-params';

@Injectable()
export class LocalidadeService extends GenericService<any> {

  constructor(http: HttpClient) {
    super('logradouro', http);
  }

  getEstados(loading?: Loading): Observable<Uf[]> {
    this.startLoading(loading);
    return this.getHttpClient()
      .get<Uf[]>(`${this.api}/uf`)
      .pipe(this.configMapAndLoading(loading));
  }

  getMunicipios(idUf: number, loading?: Loading): Observable<Municipio[]> {
    this.startLoading(loading);
    return this.getHttpClient()
      .get<Municipio[]>(`${this.api}/uf/${idUf}/municipios`)
      .pipe(this.configMapAndLoading(loading));
  }

  getPaises(loading?: Loading): Observable<ChaveValor[]> {
    this.startLoading(loading);
    return this.getHttpClient()
      .get<ChaveValor[]>(`${this.api}/paises`)
      .pipe(this.configMapAndLoading(loading));
  }

  getCep(cep: string, loading?: Loading): Observable<CEP> {
    this.startLoading(loading);
    const params = new AddHttpParams({ cep }).createParams();
    return this.getHttpClient()
      .get<CEP>(`${this.api}/cep`, { params })
      .pipe(this.configMapAndLoading(loading));
  }

}
